export const sectorDetailData = {
  overview: {
    totalTAM: 16.5,
    totalSAM: 9.6,
    avgCAGR: 28.5,
    sectorsTracked: 4,
    signalDate: '2025-12-15',
  },

  comparison: [
    {
      sector: 'AI/ML',
      tam2024: 0.15,
      tam2028: 0.80,
      cagr: 52.0,
      competition: 'LOW',
      maturity: 'EARLY',
      timing: 'NOW',
      signal: 'STRONG BUY',
      score: 94,
      risk: 'MEDIUM',
    },
    {
      sector: 'WEB3',
      tam2024: 0.04,
      tam2028: 0.25,
      cagr: 63.0,
      competition: 'VERY LOW',
      maturity: 'NASCENT',
      timing: 'NOW',
      signal: 'STRONG BUY',
      score: 91,
      risk: 'HIGH',
    },
    {
      sector: 'FINTECH',
      tam2024: 6.22,
      tam2028: 9.49,
      cagr: 11.1,
      competition: 'MEDIUM',
      maturity: 'GROWTH',
      timing: 'NOW',
      signal: 'BUY',
      score: 82,
      risk: 'LOW',
    },
    {
      sector: 'E-COMMERCE',
      tam2024: 3.20,
      tam2028: 7.50,
      cagr: 23.7,
      competition: 'HIGH',
      maturity: 'SCALING',
      timing: '6-12M',
      signal: 'HOLD',
      score: 68,
      risk: 'LOW',
    },
  ],

  fintech: {
    name: 'FINTECH',
    signal: 'BUY',
    score: 82,
    market: {
      tam2024: 6.22,
      tam2028: 9.49,
      cagr: 11.1,
      penetration: 45,
      targetPenetration: 78,
    },
    subsectors: [
      { name: 'Digital Payments', size: 2.8, cagr: 15.2, leader: 'Payme', gap: 'B2B Payments' },
      { name: 'Digital Banking', size: 1.9, cagr: 18.5, leader: 'Uzum Bank', gap: 'SME Banking' },
      { name: 'Lending', size: 0.85, cagr: 22.0, leader: 'Anorbank', gap: 'BNPL' },
      { name: 'InsurTech', size: 0.32, cagr: 28.5, leader: 'None', gap: 'WIDE OPEN' },
      { name: 'WealthTech', size: 0.18, cagr: 35.0, leader: 'None', gap: 'WIDE OPEN' },
      { name: 'Remittances', size: 0.17, cagr: 8.5, leader: 'Traditional', gap: 'Digital-first' },
    ],
    keyPlayers: [
      { name: 'Uzum', valuation: 1500, funding: 'Series B', employees: 2500, signal: 'LEADER' },
      { name: 'Payme', valuation: 450, funding: 'Series A', employees: 800, signal: 'STRONG' },
      { name: 'Click', valuation: 380, funding: 'Series A', employees: 650, signal: 'STRONG' },
      { name: 'Anorbank', valuation: 220, funding: 'Private', employees: 420, signal: 'GROWING' },
    ],
    gaps: [
      { opportunity: 'SME Neo-bank', potential: 'VERY HIGH', investment: '$10-20M', timeToMarket: '24-36M' },
      { opportunity: 'InsurTech Platform', potential: 'VERY HIGH', investment: '$3-8M', timeToMarket: '18-24M' },
      { opportunity: 'B2B Payments', potential: 'HIGH', investment: '$2-5M', timeToMarket: '12-18M' },
    ],
    regulations: {
      openBanking: 'ADVANCED',
      digitalBankLicense: 'AVAILABLE',
      sandbox: 'ACTIVE',
      foreignOwnership: '100%',
    },
  },

  ai: {
    name: 'AI / MACHINE LEARNING',
    signal: 'STRONG BUY',
    score: 94,
    market: {
      tam2024: 0.15,
      tam2028: 0.80,
      cagr: 52.0,
      penetration: 8,
      targetPenetration: 45,
    },
    subsectors: [
      { name: 'AI HealthTech', size: 0.012, cagr: 72.0, leader: 'None', gap: 'WIDE OPEN' },
      { name: 'NLP (UZ/RU)', size: 0.025, cagr: 65.0, leader: 'None', gap: 'WIDE OPEN' },
      { name: 'AI Infrastructure', size: 0.028, cagr: 58.0, leader: 'None', gap: 'WIDE OPEN' },
      { name: 'Computer Vision', size: 0.032, cagr: 55.0, leader: 'Minor', gap: 'AgriTech CV' },
      { name: 'Enterprise AI', size: 0.045, cagr: 48.0, leader: 'None', gap: 'WIDE OPEN' },
    ],
    keyPlayers: [
      { name: 'Uzum Tech', valuation: null, funding: 'Internal', employees: 200, signal: 'BUILDING' },
      { name: 'IT Park Residents', valuation: null, funding: 'Various', employees: 500, signal: 'EMERGING' },
      { name: 'University Labs', valuation: null, funding: 'Grants', employees: 150, signal: 'R&D' },
    ],
    metrics: {
      developers: 50000,
      aiStartups: 45,
      taxIncentive: '0% until 2028',
      datacenters: 3,
    },
    gaps: [
      { opportunity: 'Uzbek NLP/LLM', potential: 'VERY HIGH', investment: '$5-15M', timeToMarket: '18-24M' },
      { opportunity: 'AgriTech AI', potential: 'VERY HIGH', investment: '$3-8M', timeToMarket: '12-18M' },
      { opportunity: 'Document Processing', potential: 'HIGH', investment: '$2-5M', timeToMarket: '9-12M' },
    ],
    regulations: {
      aiPolicy: 'IN DEVELOPMENT',
      taxBenefits: '0% INCOME TAX',
      dataProtection: 'BASIC',
      foreignOwnership: '100%',
    },
  },

  web3: {
    name: 'WEB3 / CRYPTO',
    signal: 'STRONG BUY',
    score: 91,
    market: {
      tam2024: 0.04,
      tam2028: 0.25,
      cagr: 63.0,
      penetration: 3,
      targetPenetration: 25,
    },
    subsectors: [
      { name: 'Stablecoins', size: 0.003, cagr: 120.0, leader: 'None', gap: 'WIDE OPEN' },
      { name: 'DeFi', size: 0.008, cagr: 85.0, leader: 'None', gap: 'WIDE OPEN' },
      { name: 'NFT/Digital Assets', size: 0.006, cagr: 70.0, leader: 'None', gap: 'WIDE OPEN' },
      { name: 'Blockchain Services', size: 0.005, cagr: 60.0, leader: 'Minor', gap: 'Enterprise' },
      { name: 'Crypto Exchanges', size: 0.018, cagr: 55.0, leader: '3 Licensed', gap: 'UX/Fiat' },
    ],
    keyPlayers: [
      { name: 'Coinpay', valuation: 25, funding: 'Licensed', employees: 45, signal: 'FIRST MOVER' },
      { name: 'UZEX', valuation: 15, funding: 'Licensed', employees: 30, signal: 'GROWING' },
      { name: 'CryptoUZ', valuation: 10, funding: 'Licensed', employees: 20, signal: 'EMERGING' },
    ],
    metrics: {
      licensedExchanges: 3,
      regulatoryBody: 'NAPP',
      cryptoUsers: 850000,
      avgDailyVolume: 2.5,
    },
    gaps: [
      { opportunity: 'UZS Stablecoin', potential: 'VERY HIGH', investment: '$5-10M', timeToMarket: '12-18M' },
      { opportunity: 'Tokenization Platform', potential: 'VERY HIGH', investment: '$5-15M', timeToMarket: '18-24M' },
      { opportunity: 'DeFi Lending', potential: 'HIGH', investment: '$3-8M', timeToMarket: '12-18M' },
    ],
    regulations: {
      legalStatus: 'LEGAL & REGULATED',
      licensingBody: 'NAPP',
      taxRate: '12% on gains',
      foreignOwnership: '100%',
    },
  },

  ecommerce: {
    name: 'E-COMMERCE',
    signal: 'HOLD',
    score: 68,
    market: {
      tam2024: 3.20,
      tam2028: 7.50,
      cagr: 23.7,
      penetration: 12,
      targetPenetration: 35,
    },
    subsectors: [
      { name: 'Quick Commerce', size: 0.65, cagr: 45.0, leader: 'Express24', gap: 'Grocery' },
      { name: 'Social Commerce', size: 0.48, cagr: 35.0, leader: 'Instagram', gap: 'Native App' },
      { name: 'Last-mile Logistics', size: 0.27, cagr: 32.0, leader: 'Fragmented', gap: 'Consolidation' },
      { name: 'B2B E-commerce', size: 0.35, cagr: 28.0, leader: 'None', gap: 'WIDE OPEN' },
      { name: 'Marketplaces', size: 1.45, cagr: 25.0, leader: 'Uzum Market', gap: 'Verticals' },
    ],
    keyPlayers: [
      { name: 'Uzum Market', valuation: 800, funding: 'Series B', employees: 1800, signal: 'LEADER' },
      { name: 'Express24', valuation: 120, funding: 'Series A', employees: 450, signal: 'STRONG' },
      { name: 'Sello', valuation: 85, funding: 'Series A', employees: 280, signal: 'GROWING' },
      { name: 'Korzinka Go', valuation: 60, funding: 'Corporate', employees: 350, signal: 'GROWING' },
    ],
    metrics: {
      onlineShoppers: 8.5,
      avgOrderValue: 28,
      mobileShare: 82,
      returnsRate: 8,
    },
    gaps: [
      { opportunity: 'B2B Wholesale', potential: 'VERY HIGH', investment: '$8-20M', timeToMarket: '18-24M' },
      { opportunity: 'Grocery Q-commerce', potential: 'HIGH', investment: '$5-15M', timeToMarket: '12-18M' },
      { opportunity: 'Logistics Aggregator', potential: 'HIGH', investment: '$3-8M', timeToMarket: '12-18M' },
    ],
    regulations: {
      ecommLaw: 'ESTABLISHED',
      consumerProtection: 'BASIC',
      taxRate: 'STANDARD',
      foreignOwnership: '100%',
    },
  },

  projections: [
    { year: '2024', fintech: 6.22, ai: 0.15, web3: 0.04, ecomm: 3.20 },
    { year: '2025E', fintech: 6.9, ai: 0.24, web3: 0.07, ecomm: 4.0 },
    { year: '2026E', fintech: 7.6, ai: 0.38, web3: 0.11, ecomm: 5.0 },
    { year: '2027E', fintech: 8.5, ai: 0.56, web3: 0.17, ecomm: 6.2 },
    { year: '2028E', fintech: 9.49, ai: 0.80, web3: 0.25, ecomm: 7.5 },
    { year: '2029E', fintech: 10.5, ai: 1.15, web3: 0.38, ecomm: 9.0 },
    { year: '2030E', fintech: 11.8, ai: 1.65, web3: 0.55, ecomm: 10.8 },
  ],
};
